export default __webpack_public_path__ + "static/media/1987.0a7af9f7.png";